/* Shared screen carousel for the phone frames. Runs once per page. */
(function () {
  if (window.__vibeCarouselReady) { return; }
  window.__vibeCarouselReady = true;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    document.querySelectorAll('[data-vibe-carousel]').forEach(function (wrap) {
      if (wrap.dataset.vibeCarouselOn) { return; }
      wrap.dataset.vibeCarouselOn = '1';

      var track = wrap.querySelector('.islides');
      if (!track) { return; }
      var count = track.children.length;
      var dots = wrap.querySelectorAll('.idot');
      if (count < 2) { return; }

      var ms = parseInt(wrap.dataset.interval, 10);
      if (!ms || ms < 600) { ms = 1600; }

      var i = 0, timer = null;

      function go(n) {
        i = (n + count) % count;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }
      function start() { if (still) { return; } stop(); timer = setInterval(function () { go(i + 1); }, ms); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); start(); });
      });

      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      var x0 = null;
      wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); }
        x0 = null;
        start();
      }, { passive: true });

      go(0);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
